import { ModalPortal, Text } from "@livechat/design-system-react-components";

import ConfirmActionModal from "components/modals/ConfirmActionModal";
import { StackingContextLevel } from "styles/stacking-context-level";

interface IProps {
  name: string;
  onConfirm: () => void;
  onCancel: () => void;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const DeleteModal = ({ name, onConfirm, onCancel }: IProps) => (
  <ModalPortal zIndex={StackingContextLevel.Modal}>
    <ConfirmActionModal
      heading="Delete view?"
      onClose={onCancel}
      primaryAction={{
        label: "Delete",
        dataTestId: "delete-custom-view-button",
        onClick: onConfirm,
        actionType: "destructive",
      }}
      secondaryAction={{
        label: "Cancel",
        onClick: onCancel,
      }}
    >
      <Text>
        You&apos;re about to delete the <b>&ldquo;{name}&rdquo;</b> view.
        <br />
        Are you sure you want to continue?
      </Text>
    </ConfirmActionModal>
  </ModalPortal>
);

export default DeleteModal;
